import { render, staticRenderFns } from "./InsiderTipSinglePage.vue?vue&type=template&id=70dde468&scoped=true&"
import script from "./InsiderTipSinglePage.vue?vue&type=script&lang=ts&"
export * from "./InsiderTipSinglePage.vue?vue&type=script&lang=ts&"
import style0 from "./InsiderTipSinglePage.vue?vue&type=style&index=0&id=70dde468&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70dde468",
  null
  
)

export default component.exports